module.exports = __webpack_public_path__ + "static/media/lottery2.e353bb09.png";